import { useContext } from "react";

import { IDynamicFormItemProps } from ".";

import Text from "components/Text/Text";
import ToggleInput from "components/ToggleInput/ToggleInput";
import { DynamicFormContext } from "containers/DynamicForm/DynamicFormContext";

import c from "classnames";

export function ToggleInputItem({ item }: IDynamicFormItemProps<"inputToggle">) {
  const { form } = useContext(DynamicFormContext);

  const { content, key } = item;
  const { disabled, label, text } = content;
  const { value } = form.getFormInput(key);

  return (
    <div className={c("dynamic-form-item dynamic-form-item__toggle-input")}>
      <div className="toggle-input__label-wrapper">
        <Text tag="l3-label">{label}</Text>
        <ToggleInput checked={!!value} disabled={disabled} id={key} onChange={form.onChange} />
      </div>
      <Text tag="b4">{text}</Text>
    </div>
  );
}
